<template>
  <component :is="currentIcon" v-bind="$attrs" />
</template>
<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps<{
  name: string;
  isFlag?: boolean;
}>();

const currentIcon = computed(() => {
  if (props.name.startsWith('undefined-')) {
    console.error(`Icon name is undefined: ${props.name}`);
  }
  if (!props.name) {
    return undefined;
  }
  if (props.isFlag) {
    return defineAsyncComponent(() => import(`../assets/flags/${props.name}.svg`));
  }
  return defineAsyncComponent(() => import(`../assets/icons/${props.name}.svg`));
});
</script>
